<template>
  <div>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Error Message
        </v-card-title>

        <v-card-text>
          {{ questionErrorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="error = false">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="mx-auto">
      <v-icon color="primary" @click="dialog = true" title="Preview">
        visibility
      </v-icon>
      <v-dialog v-model="dialog" width="1000">
        <v-card>
          <!-- <v-layout>
          <v-flex xs1 offset-xs11 text-xs-right class="pa-2">
            <v-icon large color="#f66" @click="dialog = false">close</v-icon>
          </v-flex>
        </v-layout> -->
          <v-layout row>
            <v-flex xs12>
              <!-- <v-container fluid> -->
              <!-- <v-card> -->
              <v-card-title class="white--text error">
                <div class="headline">Response Details</div>
              </v-card-title>
              <v-card-text>
                <v-layout row>
                  <v-flex xs6>
                    <v-subheader class="black--text font-weight-regular">
                      Task Id:
                    </v-subheader>
                  </v-flex>
                  <v-flex xs6>
                    <v-subheader class="black--text font-weight-regular">
                      {{ editedItem.id }}
                    </v-subheader>
                  </v-flex>
                </v-layout>

                <v-layout row>
                  <v-flex xs6>
                    <v-subheader class="black--text font-weight-regular">
                      Project Id:
                    </v-subheader>
                  </v-flex>
                  <v-flex xs6>
                    <v-subheader class="black--text font-weight-regular">
                      {{ editedItem.project_id }}
                    </v-subheader>
                  </v-flex>
                </v-layout>

                <v-layout row>
                  <v-flex xs6>
                    <v-subheader class="black--text font-weight-regular">
                      Dasher ID:
                    </v-subheader>
                  </v-flex>
                  <v-flex xs6>
                    <v-subheader class="black--text font-weight-regular">
                      {{ editedItem.dasher_id }}
                    </v-subheader>
                  </v-flex>
                </v-layout>

                <v-layout row>
                  <v-flex xs6>
                    <v-subheader class="black--text font-weight-regular">
                      Task Starting Time:
                    </v-subheader>
                  </v-flex>
                  <v-flex xs6>
                    <v-subheader class="black--text font-weight-regular">
                      {{ editedItem.started_at }}
                    </v-subheader>
                  </v-flex>
                </v-layout>

                <v-layout row>
                  <v-flex xs6>
                    <v-subheader class="black--text font-weight-regular">
                      Task Completed Time:
                    </v-subheader>
                  </v-flex>
                  <v-flex xs6>
                    <v-subheader class="black--text font-weight-regular">
                      {{ editedItem.completed_at }}
                    </v-subheader>
                  </v-flex>
                </v-layout>

                <v-layout row v-if="editedItem.accepted_at">
                  <v-flex xs6>
                    <v-subheader class="black--text font-weight-regular">
                      Task Accepted At:
                    </v-subheader>
                  </v-flex>
                  <v-flex xs6>
                    <v-subheader class="black--text font-weight-regular">
                      {{ editedItem.accepted_at }}
                    </v-subheader>
                  </v-flex>
                </v-layout>

                <v-layout row v-if="editedItem.accepted_by">
                  <v-flex xs6>
                    <v-subheader class="black--text font-weight-regular">
                      Task Accepted by:
                    </v-subheader>
                  </v-flex>
                  <v-flex xs6>
                    <v-subheader class="black--text font-weight-regular">
                      {{ editedItem.accepted_by }}
                    </v-subheader>
                  </v-flex>
                </v-layout>

                <v-layout row v-if="editedItem.rejected_at">
                  <v-flex xs6>
                    <v-subheader class="black--text font-weight-regular">
                      Task Rejected At:
                    </v-subheader>
                  </v-flex>
                  <v-flex xs6>
                    <v-subheader class="black--text font-weight-regular">
                      {{ editedItem.rejected_at }}
                    </v-subheader>
                  </v-flex>
                </v-layout>

                <v-layout row v-if="editedItem.rejected_by">
                  <v-flex xs6>
                    <v-subheader class="black--text font-weight-regular">
                      Task Rejected by:
                    </v-subheader>
                  </v-flex>
                  <v-flex xs6>
                    <v-subheader class="black--text font-weight-regular">
                      {{ editedItem.rejected_by }}
                    </v-subheader>
                  </v-flex>
                </v-layout>

                <!-- <v-layout row>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">
                        Task Accept At
   :                   </v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">
                        {{ editedItem.accepted_at }}
   :                   </v-subheader>
                    </v-flex>
                  </v-layout>

                  <v-layout row>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">
                        Task Accepted By
   :                   </v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">
                        {{ editedItem.accepted_by }}
   :                   </v-subheader>
                    </v-flex>
                  </v-layout> -->

                <v-layout row>
                  <v-flex xs6>
                    <v-subheader class="black--text font-weight-regular">
                      Total Response Time:
                    </v-subheader>
                  </v-flex>
                  <v-flex xs6>
                    <v-subheader class="black--text font-weight-regular">
                      {{ totalResponseTime }} Sec:
                    </v-subheader>
                  </v-flex>
                </v-layout>

                <v-layout row>
                  <v-flex xs6>
                    <v-subheader class="black--text font-weight-regular">
                      Response Time Average:
                    </v-subheader>
                  </v-flex>
                  <v-flex xs6>
                    <v-subheader class="black--text font-weight-regular">
                      {{ avgResTime }} Sec:
                    </v-subheader>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <!-- </v-card> -->
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12>
              <!-- <v-card> -->
              <v-card-title
                class="error white--text"
                v-if="editedItem.has_pre_survey"
              >
                <div class="headline">Pre Survey Question & Answer</div>
              </v-card-title>
              <v-card-text v-if="editedItem.has_pre_survey">
                <div v-for="(pre_ques, i) in preSurveyQuestions.data" :key="i">
                  <v-layout>
                    <v-flex sm1 class="mt-2">
                      <v-layout>
                        <v-flex sm6>
                          <h3>{{ i + 1 }}.</h3>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex sm11>
                      <div>
                        <span
                          v-if="
                            editedItem.project_language == 1 ||
                            editedItem.project_language == 3
                          "
                        >
                          <span class="font-weight-bold">
                            Question Title English:
                          </span>
                          {{ pre_ques.question_title_en }}
                        </span>
                      </div>
                      <div
                        v-if="
                          editedItem.project_language == 2 ||
                          editedItem.project_language == 3
                        "
                      >
                        <span class="font-weight-bold">
                          Question Title Bangla:
                        </span>
                        {{ pre_ques.question_title_bn }}
                      </div>
                      <div class="mt-2">
                        <span>
                          <b>Question Type:</b>
                          {{ pre_ques.ui_category }}
                        </span>
                      </div>

                      <v-layout class="mt-2">
                        <v-flex sm1>
                          <span class="font-weight-bold">Answer:</span>
                        </v-flex>
                        <v-flex sm11 style="color: #171">
                          <div v-if="pre_ques.ui_category_id == 14">
                            <div>
                              <!-- {{
                              showResponseForImageName(
                                editedItem[
                                  ques.question_sequence
                                    ? getQuestionVariable(
                                        ques.question_sequence
                                      )
                                    : ques.question_variable
                                ],
                                ques
                              )
                            }} -->
                            </div>
                            <div>
                              <v-img
                                v-if="
                                  editedItem[
                                    ques.question_sequence
                                      ? getQuestionVariable(
                                          ques.question_sequence
                                        )
                                      : ques.question_variable
                                  ]
                                "
                                height="150"
                                width="200"
                                :src="
                                  indexData.mul_choice_image +
                                  showResponseForImage(
                                    editedItem[
                                      ques.question_sequence
                                        ? getQuestionVariable(
                                            ques.question_sequence
                                          )
                                        : ques.question_variable
                                    ],
                                    ques
                                  )
                                "
                              ></v-img>
                              <a
                                v-if="
                                  editedItem[
                                    ques.question_sequence
                                      ? getQuestionVariable(
                                          ques.question_sequence
                                        )
                                      : ques.question_variable
                                  ]
                                "
                                :href="
                                  indexData.mul_choice_image +
                                  showResponseForImage(
                                    editedItem[
                                      ques.question_sequence
                                        ? getQuestionVariable(
                                            ques.question_sequence
                                          )
                                        : ques.question_variable
                                    ],
                                    ques
                                  )
                                "
                                target="_blank"
                              >
                                download
                              </a>
                            </div>
                          </div>
                          <div
                            v-else-if="
                              pre_ques.ui_category_id == 1 ||
                              pre_ques.ui_category_id == 2 ||
                              pre_ques.ui_category_id == 4
                            "
                          >
                            <div>
                              {{
                                pre_ques.pre_options[
                                  parseInt(preRes[pre_ques.question_variable]) -
                                    1
                                ].title
                              }}
                            </div>
                          </div>

                          <div v-if="pre_ques.ui_category_id == 18">
                            <div>
                              {{
                                editedItem[
                                  pre_ques.question_sequence
                                    ? getQuestionVariable(
                                        pre_ques.question_sequence
                                      )
                                    : pre_ques.question_variable
                                ]
                              }}
                            </div>
                          </div>
                        </v-flex>
                      </v-layout>
                      <br />
                      <br />
                    </v-flex>
                  </v-layout>
                </div>
              </v-card-text>
              <!-- <v-card> -->
              <v-form ref="form" v-model="valid" lazy-validation class="ma-2">
                <v-card-title class="error white--text">
                  <div class="headline">Question & Answer</div>
                </v-card-title>
                <v-card-text>
                  <div v-if="editedItem.project_type_id == 2">
                    <b>Task Accepted Location</b>
                    <br />
                    <span>
                      <b>Latitude:</b>
                      {{ editedItem.latitude }}
                    </span>
                    <br />
                    <span>
                      <b>Longitude:</b>
                      {{ editedItem.longitude }}
                    </span>
                  </div>
                  <div v-for="(ques, i) in questions.data" :key="i">
                    <v-layout>
                      <v-flex sm1 class="mt-2">
                        <v-layout>
                          <v-flex sm6>
                            <v-checkbox
                              primary
                              hide-details
                              v-if="status == 2"
                              v-model="selectedItem.checkbox[i].data"
                              class="mt-0 pt-0"
                            ></v-checkbox>
                          </v-flex>
                          <v-flex sm6>
                            <h3>{{ i + 1 }}.</h3>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex sm11>
                        <div>
                          <span
                            v-if="
                              editedItem.project_language == 1 ||
                              editedItem.project_language == 3
                            "
                          >
                            <span class="font-weight-bold">
                              Question Title English:
                            </span>
                            {{ ques.question }}
                            <span
                              class="red--text headline"
                              v-if="ques.required_optional == 1"
                            >
                              *
                            </span>
                          </span>
                        </div>
                        <div
                          v-if="
                            editedItem.project_language == 2 ||
                            editedItem.project_language == 3
                          "
                        >
                          <span class="font-weight-bold">
                            Question Title Bangla:
                          </span>
                          {{ ques.question_bangla }}
                          <span
                            class="red--text headline"
                            v-if="ques.required_optional == 1"
                          >
                            *
                          </span>
                        </div>
                        <div class="mt-2">
                          <span>
                            <b>Question Type:</b>
                            {{ ques.ui_category }}
                          </span>
                        </div>

                        <v-layout class="mt-2">
                          <v-flex sm1>
                            <span class="font-weight-bold">Answer:</span>
                          </v-flex>
                          <v-flex sm11 style="color: #171">
                            <div
                              v-if="
                                ques.ui_category_id == 9 ||
                                ques.ui_category_id == 19 ||
                                ques.ui_category_id == 20
                              "
                            >
                              <div>
                                <MultipleResponseView
                                  :multipleData="
                                    editedItem[
                                      ques.question_sequence
                                        ? getQuestionVariable(
                                            ques.question_sequence
                                          )
                                        : ques.question_variable
                                    ]
                                  "
                                  :res_video="res_video"
                                  :res_audio="res_audio"
                                  :res_image="res_image"
                                  :res_file="res_file"
                                ></MultipleResponseView>
                              </div>
                            </div>

                            <div v-else-if="ques.ui_category_id == 10">
                              <div v-if="ques.multiple_answer == '1'">
                                <MultipleResponseView
                                  v-if="
                                    editedItem[
                                      ques.question_sequence
                                        ? getQuestionVariable(
                                            ques.question_sequence
                                          )
                                        : ques.question_variable
                                    ]
                                  "
                                  :multipleData="
                                    editedItem[
                                      ques.question_sequence
                                        ? getQuestionVariable(
                                            ques.question_sequence
                                          )
                                        : ques.question_variable
                                    ]
                                  "
                                ></MultipleResponseView>
                              </div>
                              <div v-else>
                                <audio
                                  width="200"
                                  v-if="
                                    editedItem[
                                      ques.question_sequence
                                        ? getQuestionVariable(
                                            ques.question_sequence
                                          )
                                        : ques.question_variable
                                    ]
                                  "
                                  controls
                                >
                                  <source
                                    :src="
                                      res_audio +
                                      editedItem[
                                        ques.question_sequence
                                          ? getQuestionVariable(
                                              ques.question_sequence
                                            )
                                          : ques.question_variable
                                      ]
                                    "
                                    type="audio/mp3"
                                  />
                                  Your browser does not support HTML audio.
                                </audio>
                                <br />
                                <a
                                  v-if="
                                    editedItem[
                                      ques.question_sequence
                                        ? getQuestionVariable(
                                            ques.question_sequence
                                          )
                                        : ques.question_variable
                                    ]
                                  "
                                  :href="
                                    res_audio +
                                    editedItem[
                                      ques.question_sequence
                                        ? getQuestionVariable(
                                            ques.question_sequence
                                          )
                                        : ques.question_variable
                                    ]
                                  "
                                  target="_blank"
                                >
                                  download
                                </a>
                              </div>
                            </div>

                            <div v-else-if="ques.ui_category_id == 11">
                              <div v-if="ques.multiple_answer == '1'">
                                <MultipleResponseView
                                  :multipleData="
                                    editedItem[
                                      ques.question_sequence
                                        ? getQuestionVariable(
                                            ques.question_sequence
                                          )
                                        : ques.question_variable
                                    ]
                                  "
                                ></MultipleResponseView>
                              </div>
                              <div v-else>
                                <video
                                  width="200"
                                  v-if="
                                    editedItem[
                                      ques.question_sequence
                                        ? getQuestionVariable(
                                            ques.question_sequence
                                          )
                                        : ques.question_variable
                                    ]
                                  "
                                  controls
                                >
                                  <source
                                    :src="
                                      res_video +
                                      editedItem[
                                        ques.question_sequence
                                          ? getQuestionVariable(
                                              ques.question_sequence
                                            )
                                          : ques.question_variable
                                      ]
                                    "
                                    type="video/mp4"
                                  />
                                  Your browser does not support HTML video.
                                </video>
                                <br />
                                <a
                                  v-if="
                                    editedItem[
                                      ques.question_sequence
                                        ? getQuestionVariable(
                                            ques.question_sequence
                                          )
                                        : ques.question_variable
                                    ]
                                  "
                                  :href="
                                    res_video +
                                    editedItem[
                                      ques.question_sequence
                                        ? getQuestionVariable(
                                            ques.question_sequence
                                          )
                                        : ques.question_variable
                                    ]
                                  "
                                  target="_blank"
                                >
                                  download
                                </a>
                              </div>
                            </div>

                            <div v-else-if="ques.ui_category_id == 15">
                              <div
                                v-if="
                                  editedItem[
                                    ques.question_sequence
                                      ? getQuestionVariable(
                                          ques.question_sequence
                                        )
                                      : ques.question_variable
                                  ]
                                "
                              >
                                <ContactInfoResponse
                                  :contactForm="
                                    editedItem[
                                      ques.question_sequence
                                        ? getQuestionVariable(
                                            ques.question_sequence
                                          )
                                        : ques.question_variable
                                    ]
                                  "
                                />
                              </div>
                            </div>

                            <div v-else-if="ques.ui_category_id == 14">
                              <div>
                                {{
                                  showResponseForImageName(
                                    editedItem[
                                      ques.question_sequence
                                        ? getQuestionVariable(
                                            ques.question_sequence
                                          )
                                        : ques.question_variable
                                    ],
                                    ques
                                  )
                                }}
                              </div>
                              <div>
                                <v-img
                                  v-if="
                                    editedItem[
                                      ques.question_sequence
                                        ? getQuestionVariable(
                                            ques.question_sequence
                                          )
                                        : ques.question_variable
                                    ]
                                  "
                                  height="150"
                                  width="200"
                                  :src="
                                    indexData.mul_choice_image +
                                    showResponseForImage(
                                      editedItem[
                                        ques.question_sequence
                                          ? getQuestionVariable(
                                              ques.question_sequence
                                            )
                                          : ques.question_variable
                                      ],
                                      ques
                                    )
                                  "
                                ></v-img>
                                <a
                                  v-if="
                                    editedItem[
                                      ques.question_sequence
                                        ? getQuestionVariable(
                                            ques.question_sequence
                                          )
                                        : ques.question_variable
                                    ]
                                  "
                                  :href="
                                    indexData.mul_choice_image +
                                    showResponseForImage(
                                      editedItem[
                                        ques.question_sequence
                                          ? getQuestionVariable(
                                              ques.question_sequence
                                            )
                                          : ques.question_variable
                                      ],
                                      ques
                                    )
                                  "
                                  target="_blank"
                                >
                                  download
                                </a>
                              </div>
                            </div>
                            <div v-else-if="ques.ui_category_id == 2">
                              <div
                                v-for="(item, index1) in showMultipleResponse(
                                  editedItem[
                                    ques.question_sequence
                                      ? getQuestionVariable(
                                          ques.question_sequence
                                        )
                                      : ques.question_variable
                                  ],
                                  ques
                                )"
                                :key="index1"
                              >
                                <li>{{ item }}</li>
                              </div>
                            </div>

                            <div
                              v-else-if="
                                ques.ui_category_id == 1 ||
                                ques.ui_category_id == 4
                              "
                            >
                              <div v-if="ques.multiple_answer == '1'">
                                <div
                                  v-for="(item, index1) in showMultipleResponse(
                                    editedItem[
                                      ques.question_sequence
                                        ? getQuestionVariable(
                                            ques.question_sequence
                                          )
                                        : ques.question_variable
                                    ],
                                    ques
                                  )"
                                  :key="index1"
                                >
                                  <li>{{ item }}</li>
                                </div>
                              </div>
                              <div v-else>
                                {{
                                  showResponse(
                                    editedItem[
                                      ques.question_sequence
                                        ? getQuestionVariable(
                                            ques.question_sequence
                                          )
                                        : ques.question_variable
                                    ],
                                    ques
                                  )
                                }}
                              </div>
                            </div>

                            <div v-else>
                              <div v-if="ques.multiple_answer == '1'">
                                <MultipleResponseView
                                  :multipleData="
                                    editedItem[
                                      ques.question_sequence
                                        ? getQuestionVariable(
                                            ques.question_sequence
                                          )
                                        : ques.question_variable
                                    ]
                                  "
                                ></MultipleResponseView>
                              </div>
                              <div v-else>
                                {{
                                  editedItem[
                                    ques.question_sequence
                                      ? getQuestionVariable(
                                          ques.question_sequence
                                        )
                                      : ques.question_variable
                                  ]
                                }}
                              </div>
                            </div>
                          </v-flex>
                        </v-layout>

                        <div v-if="timeExpense" class="mt-2">
                          <b>Time expense:</b>

                          {{
                            editedItem[
                              ques.question_sequence
                                ? getQuestionVariable(ques.question_sequence)
                                : ques.question_variable
                            ]
                              ? showResponseTime(
                                  timeExpense,
                                  ques.question_sequence
                                )
                              : "NULL"
                          }}
                        </div>

                        <div v-if="editedItem.task_status_id == 3" class="mt-2">
                          <b>Comment:</b>
                          {{ showComment(ques.modify_comments, ques.id) }}
                        </div>

                        <!-- here is comment field for a single question -->
                        <br />
                        <div
                          v-if="
                            status == 2 && selectedItem.checkbox[i].data == true
                          "
                        >
                          <v-text-field
                            label="Write your message"
                            v-model="selectedItem.checkbox[i].value"
                            :rules="commentRules"
                            box
                            required
                          ></v-text-field>
                        </div>
                        <br />
                        <br />
                      </v-flex>
                    </v-layout>
                  </div>
                </v-card-text>
                <div v-if="status == 2 && selectedItem.checkbox.length > 0">
                  <v-list-tile-title class="font-weight-bold text-sm-center">
                    Modification Time & Comment
                  </v-list-tile-title>
                  <v-layout row justify-space-around>
                    <v-flex xs12>
                      <!-- <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                    class="ma-2"
                  > -->
                      <div class="ml-2 font-weight-bold">
                        Setup Modification Time
                      </div>
                      <v-layout row>
                        <v-flex xs4 class="ml-2">
                          <v-text-field
                            v-model="selectedItem.days"
                            :rules="day"
                            label="Modification Ending(Days)"
                            type="number"
                            box
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs4 class="ml-2">
                          <v-text-field
                            v-model="selectedItem.hours"
                            :rules="hour"
                            label="Modification Ending(Hours)"
                            type="number"
                            box
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs4 class="ml-2">
                          <v-text-field
                            v-model="selectedItem.minutes"
                            :rules="minutes"
                            label="Modification Ending(Minutes)"
                            type="number"
                            box
                            required
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row>
                        <v-flex xs12>
                          <v-text-field
                            v-model="selectedItem.comment"
                            :rules="commentRules"
                            label="Write your final comments"
                            box
                            required
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <!-- </v-form> -->
                    </v-flex>
                  </v-layout>
                </div>
              </v-form>
              <!-- </v-card> -->
            </v-flex>
          </v-layout>
          <!-- </v-container> -->
          <!-- </v-flex>
        </v-layout> -->
          <v-layout row v-if="status == 2" class="pa-2">
            <div>
              <v-btn color="success" @click="acceptItem(editedItem)">
                Accept
              </v-btn>
              <v-btn color="red" @click="close">Cancel</v-btn>
              <v-btn color="primary" @click="editItem(editedItem)"
                >Modify</v-btn
              >
              <v-btn color="warning" @click="rejectItem(editedItem)">
                Reject
              </v-btn>
            </div>
          </v-layout>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import MultipleResponseView from "../../views/response/MultipleResponseView";
import api from "../../api/datadash";
export default {
  components: { MultipleResponseView },
  props: [
    "editedItem",
    "openPreview",
    "questions",
    "status",
    "res_audio",
    "res_image",
    "res_video",
    "res_file",
  ],
  data() {
    return {
      dialog: false,
      error: false,
      questionErrorMsg: false,
      totalResponseTime: 0,
      avgResTime: 0,
      timeExpense: null,
      preSurveyQuestions: {},
      preRes: {},
      selectedItem: {
        project_id: "",
        dasher_id: "",
        task_id: "",
        comment: "",
        days: "",
        hours: "",
        minutes: "",
        checkbox: [],
      },

      projectID: "",
      defaultItem: {},
      valid: true,
      commentRules: [
        (v) =>
          !!v ||
          "This field is required if you need to modify any question else skip this!",
      ],
      day: [(v) => !!v || "Minimum value is required 0"],
      hour: [(v) => !!v || "Minimum value is required 0"],
      minutes: [(v) => !!v || "Minimum value is required 1"],
    };
  },

  computed: {
    ...mapGetters(["indexData"]),
    ...mapState(["auth"]),
  },

  created() {
    if (this.editedItem.has_pre_survey) {
      this.getResponse(this.editedItem);
    }
    this.checkedItem();
    this.checkItem();
  },

  methods: {
    checkedItem() {
      let length = this.questions.data.length;
      for (let i = 0; i < length; i++) {
        this.selectedItem.checkbox.push({
          data: false,
          value: null,
        });
      }
    },
    checkItem() {
      if (this.editedItem.duration_json) {
        this.timeExpense = JSON.parse(this.editedItem.duration_json);
      }
      var num_of_res = 0;
      var response_time = 0;
      this.timeExpense.forEach((element) => {
        const arrayFailed = Object.entries(element).map((arr) => ({
          fieldName: arr[0],
          value: arr[1],
        }));
        if (parseInt(arrayFailed[0].value)) {
          num_of_res += 1;
        }
        response_time = response_time + parseInt(arrayFailed[0].value);
      });
      this.totalResponseTime = response_time;
      this.avgResTime = Math.round(response_time / num_of_res);
      // this.dialog = true;
    },
    getQuestionVariable(questionSequence) {
      return "var" + questionSequence;
      // console.log(questionSequence);
    },

    showResponseForImage(value, question_data) {
      // console.log(value);
      return question_data.imageOptions[parseInt(value) - 1].url;
    },

    showResponseTime(time_array, question_data) {
      var response_time = "";

      time_array.forEach((element) => {
        const arrayFailed = Object.entries(element).map((arr) => ({
          fieldName: arr[0],
          message: arr[1],
        }));
        if (arrayFailed[0].fieldName == "var" + question_data) {
          response_time = arrayFailed[0].message + " Sec";
        }
      });
      return response_time;
    },

    showResponseForImageName(value, question_data) {
      if (!value) {
        return null;
      }
      return question_data.imageOptions[parseInt(value) - 1].title;
    },

    showResponse(value, question_data) {
      // console.log(value);
      // if (value.includes("|")) {
      //   console.log("contains");
      // }
      if (value) {
        var valueInt = parseInt(value);
        if (
          (isNaN(valueInt) || value.length > 2) &&
          parseInt(question_data.project_id) < 20
        ) {
          return value;
        }
        var return_title = "";
        if (
          (question_data.ui_category_id == 1 ||
            question_data.ui_category_id == 2 ||
            question_data.ui_category_id == 4) &&
          this.editedItem.project_language == 1
        ) {
          if (valueInt == 1111) {
            return "Others";
          } else if (valueInt == 9999) {
            return "None of above";
          }
          return question_data.options[valueInt - 1].title;
        } else if (
          (question_data.ui_category_id == 1 ||
            question_data.ui_category_id == 2 ||
            question_data.ui_category_id == 4) &&
          this.editedItem.project_language == 2
        ) {
          if (valueInt == 1111) {
            return "অন্যান্য";
          } else if (valueInt == 9999) {
            return "উপরের কোনটিই নয়";
          }
          return question_data.bangla_options[valueInt - 1].title;
        } else if (
          (question_data.ui_category_id == 1 ||
            question_data.ui_category_id == 2 ||
            question_data.ui_category_id == 4) &&
          this.editedItem.project_language == 3
        ) {
          if (valueInt == 1111) {
            return "Others(অন্যান্য)";
          } else if (valueInt == 9999) {
            return "None of above(উপরের কোনটিই নয়)";
          }
          return (
            question_data.options[valueInt - 1].title +
            "(" +
            question_data.bangla_options[valueInt - 1].title +
            ")"
          );
        }
        return return_title;
      } else {
        return null;
      }
    },

    showComment(comment, quesId) {
      comment.filter((element) => {
        this.editedItem.id == element.task_id && element.question_id == quesId;
      });
      // console.log(comment[0].comment_per_question);
      // console.log(this.editedItem.id);
      return comment.length ? comment[0].comment_per_question : "";
    },

    showMultipleResponse(value, question_data) {
      // console.log(value);
      if (value == "|") {
        // console.log("split");
        // console.log(value.split("|"));
        return ["NULL"];
      }
      if (value) {
        var return_title = [];
        if (
          (question_data.ui_category_id == 1 ||
            question_data.ui_category_id == 2 ||
            question_data.ui_category_id == 4) &&
          this.editedItem.project_language == 1
        ) {
          value.split("|").forEach((element) => {
            if (
              (isNaN(parseInt(element)) || value.length > 2) &&
              question_data.project_id < 20
            ) {
              return_title.push(element);
            } else if (parseInt(element) == 1111) {
              return_title.push("Others");
            } else if (parseInt(element) == 9999) {
              return_title.push("None of above");
            } else {
              return_title.push(
                question_data.options[parseInt(element) - 1].title
              );
            }
          });
        } else if (
          (question_data.ui_category_id == 1 ||
            question_data.ui_category_id == 2 ||
            question_data.ui_category_id == 4) &&
          this.editedItem.project_language == 2
        ) {
          value.split("|").forEach((element) => {
            if (
              (isNaN(parseInt(element)) || value.length > 2) &&
              question_data.project_id < 20
            ) {
              return_title.push(element);
            } else if (parseInt(element) == 1111) {
              return_title.push("Others");
            } else if (parseInt(element) == 9999) {
              return_title.push("None of above");
            } else {
              return_title.push(
                question_data.bangla_options[parseInt(element) - 1].title
              );
            }
          });
        } else if (
          (question_data.ui_category_id == 1 ||
            question_data.ui_category_id == 2 ||
            question_data.ui_category_id == 4) &&
          this.editedItem.project_language == 3
        ) {
          value.split("|").forEach((element) => {
            if (
              (isNaN(parseInt(element)) || value.length > 2) &&
              question_data.project_id < 20
            ) {
              return_title.push(element);
            } else if (parseInt(element) == 1111) {
              return_title.push("Others(অন্যান্য))");
            } else if (parseInt(element) == 9999) {
              return_title.push("None of above(উপরের কোনটিই নয়)");
            } else {
              return_title.push(
                question_data.options[parseInt(element) - 1].title +
                  "(" +
                  question_data.bangla_options[parseInt(element) - 1].title +
                  ")"
              );
            }
          });
        }
        // console.log(return_title);
        return return_title;
      } else {
        return ["NULL"];
      }
    },
    async acceptItem(item) {
      var popUpMsg = confirm("Are you sure want to accept this application?");
      if (popUpMsg) {
        try {
          await api.fetchData(
            this.auth.token,
            `accept/${item.id}/${item.project_id}`
          );
          this.$emit("reset");
        } catch (e) {
          //
        }
      }
      this.close();
    },

    async getResponse(item) {
      // console.log(item.project_id);
      try {
        const { data } = await api.fetchData(
          this.auth.token,
          `task/${item.project_id}/${item.id}`
        );
        // console.log(data.data);
        this.preSurveyQuestions = data.data.preSurveyQuestions;
        this.preRes = data.data.pre_response;
      } catch (e) {
        //
      }

      this.close();
    },

    // set dynamic comment here
    async editItem(item) {
      // console.log(this.selectedItem)
      if (this.$refs.form.validate()) {
        this.selectedItem.project_id = item.project_id;
        this.selectedItem.dasher_id = item.dasher_id;
        this.selectedItem.task_id = item.id;
        var count = 0;
        for (let i = 0; i < this.selectedItem.checkbox.length; i++) {
          if (this.selectedItem.checkbox[i].data == true) {
            this.selectedItem.checkbox[i].data = this.questions.data[i].id;
            count = count + 1;
          }
        }
        this.selectedItem.checkbox = this.selectedItem.checkbox.filter(
          (item) => item.data != false
        );
        this.counter = this.selectedItem.checkbox.length;
        // this.counter = count;
        if (this.counter == 0) {
          var popUpMsg = confirm(
            "Please check questions those want to modify!"
          );
          if (popUpMsg) {
            this.dialog = true;
          } else {
            this.close();
          }
        } else {
          // console.log(this.selectedItem)
          let popUpMsg = confirm(
            "Are you sure want to permit for modification?"
          );

          if (popUpMsg) {
            try {
              let response = await api.storeData(
                this.auth.token,
                "modify",
                this.selectedItem
              );
              // console.log(response);
              if (response.data.error) {
                this.error = true;
                this.questionErrorMsg = response.data.errorMsg;
              } else {
                this.$emit("reset");
                this.close();
              }
            } catch (e) {
              //
            }
          }
        }
      }
    },

    async rejectItem(item) {
      // console.log(item.project_id);
      var popUpMsg = confirm(
        "Are you sure you want to reject this application?"
      );
      if (popUpMsg) {
        try {
          await api.fetchData(
            this.auth.token,
            `reject/${item.id}/${item.project_id}`
          );
          this.$emit("reset");
        } catch (e) {
          //
        }
      }
      this.close();
    },

    close() {
      this.dialog = false;
      this.totalResponseTime = 0;
      this.avgResTime = 0;
      // setTimeout(() => {
      //   this.editedItem = Object.assign({}, this.defaultItem);
      //   this.editedIndex = -1;
      //   this.counter = 0;
      // }, 300);
    },
  },
};
</script>
